module.exports = __webpack_public_path__ + "static/media/System_supervisor.817cbbd5.svg";